import { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import { FaChevronRight } from "react-icons/fa6"
import { Button } from 'react-bootstrap'

import bg_platform_1 from './../assets/15082511_v617batch2-bb-01-technology2.png'
import bg_platform_2 from './../assets/bg_platform_2.png'
import bg_platform_3 from './../assets/bg_platform_3.png'
import bg_platform_4 from './../assets/bg_platform_4.png'
import bg_platform_5 from './../assets/bg_platform_5.png'
import bg_platform_6 from './../assets/bg_platform_6.png'
import bg_platform_7 from './../assets/bg_platform_7.png'
import bg_platform_8 from './../assets/bg_platform_8.png'
import bg_platform_9 from './../assets/bg_platform_9.png'
import bg_platform_10 from './../assets/bg_platform_10.png'
import bg_platform_11 from './../assets/bg_platform_11.png'
import bg_platform_12 from './../assets/bg_platform_12.png'
import bg_platform_13 from './../assets/bg_platform_13.png'
import bg_platform_14 from './../assets/bg_platform_14.png'

const list = [
  {
    title: "Cloud Native Application Protection Platform (CNAPP)",
    snippet: "Secure your entire cloud; AWS, Azure, Google Cloud & Kubernetes with 100% visibility and no agents. Prioritize real risks, not noise.",
    image: bg_platform_1,
    link: '/solutions/cloud-native-application-protection-platform'
  },
  {
    title: "Cloud Security Posture Management (CSPM)",
    snippet: "Keep your cloud setup safe and compliant. Orca finds misconfigurations before they turn into problems.",
    image: bg_platform_2,
    link: 'solutions/cloud-security-posture-management'
  },
  {
    title: "Cloud Workload Protection Platform (CWPP)",
    snippet: "Protect your systems and apps in the cloud  without slowing anything down. Setup takes minutes.",
    image: bg_platform_3,
    link: '/solutions/cloud-workload-protection-platform'
  },
  {
    title: "Cloud Infrastructure Entitlement Management (CIEM)",
    snippet: "Orca finds risky or excessive access in your cloud and links it to other threats like misconfigurations or exposed data so you know what to fix first.",
    image: bg_platform_4,
    link: '/solutions/cloud-infrastructure-entitlement-management'
  },
  {
    title: "Data Security Posture Management (DSPM)",
    snippet: "Discover where your sensitive data lives in the cloud and get alerts if it’s exposed or at risk.",
    image: bg_platform_5,
    link: '/solutions/data-security-posture-management'
  },
  {
    title: "Container and Kubernetes Security",
    snippet: "Scan containers and Kubernetes environments with no agents. Get clear insight into any security gaps.",
    image: bg_platform_6,
    link: '/solutions/container-and-kubernetes-security'
  },
  {
    title: "Multi Cloud Compliance",
    snippet: "Stay compliant across AWS, Azure, GCP, and more. Orca runs automatic checks on your cloud setup and helps you fix issues fast, no agents needed.",
    image: bg_platform_7,
    link: '/solutions/multi-cloud-compliance'
  },
  {
    title: "Vulnerability Management",
    snippet: "Detect and prioritize real weaknesses across apps, systems, and configurations with no manual effort.",
    image: bg_platform_8,
    link: '/solutions/vulnerability-management'
  },
  {
    title: "API Security",
    snippet: "Get full visibility into your APIs  without agents. Orca identifies API-related risks, including vulnerabilities, misconfigurations, malware, and exposed data, so you can protect what matters.",
    image: bg_platform_9,
    link: '/solutions/api-security'
  },
  {
    title: "Cloud Threat Detection & Response (CDR)",
    snippet: "Monitor your cloud 24/7. Orca analyzes logs, assets, and cloud activity to detect and prioritize threats fast and accurate",
    image: bg_platform_10,
    link: '/solutions/cloud-detection-and-response'
  },
  {
    title: "Shift Left Security",
    snippet: "Secure your apps from the start. Orca scans code, containers, and infrastructure before deployment, helping developers catch and fix risks early.",
    image: bg_platform_11,
    link: '/solutions/shift-left-security'
  },
  {
    title: "AI Security Posture ManagementAI Security Posture Management",
    snippet: "See the risks hiding in your AI systems. Orca gives deep, agentless visibility into 50+ AI tools and models, helping you keep your entire cloud secure.",
    image: bg_platform_12,
    link: '/solutions/ai-security-posture-management'
  },
  {
    title: "AI-Powered Cloud Security",
    snippet: "Let AI do the heavy lifting. Orca uses AI to simplify your cloud security reducing alerts, saving time, and helping your team focus on what matters.",
    image: bg_platform_13,
    link: '/solutions/ai-driven-cloud-security'
  },
  {
    title: "Agentless SideScanning",
    snippet: "Scan everything. Install nothing. Orca reads cloud data directly from storage no agents needed  to deliver full risk analysis without slowing down your systems.",
    image: bg_platform_14,
    link: '/solutions/agentless-sidescanning'
  },
]

const rows = 8

function Platform() {
  const [data, setData] = useState([])
  const [idx, setIdx] = useState(0)
  const [limit, setLimit] = useState(rows)

  const loadMore = () => {
    setIdx(idx + rows)
    setLimit(limit + rows)
  }

  useEffect(() => {
    setData(state => [...state, ...list.slice(idx, limit)])
  }, [idx, limit])

  return (
    <div className='category ps-5 pe-5 pt-5'>
      <Row>
        {
          data.map((item, index) => (
            <Col key={'playform-'+index} md={3} xs={12} className='mb-4'>
              <div 
                className='platform-card h-100'
                style={{ backgroundImage: `url(${item.image})` }}
              >
                <div className='title'>{item.title}</div>
                <div className='snipet'>
                  <p className='mt-4'>{item.snippet}</p>
                  <a href={item.link} style={{textDecoration:"none"}}>
                    <div className="mt-5 d-flex flex-row justify-content-end w-100 align-items-center gap-2 text-white">
                      <div>Expand</div>
                      <FaChevronRight size={12}/>
                    </div>
                  </a>
                </div>
              </div>
            </Col>
          ))
        }
      </Row>
      
      {
        data.length < list.length &&
        <div className="mt-3 w-100 text-center">
          <Button variant='brand' onClick={loadMore}>Load More</Button>
        </div>
      }
    </div>
  )
}

export default Platform;